export interface ThumbnailsCredentialsSchema {
  host: string;
  token: string;

  valid_for: number;
}

export const resolveThumbnailsCredentials = (fetch: typeof window.fetch) => (env: string) => {
  return fetch(`//${env}.cloudinary.com/console/api/v1/auth/thumbnails_token`, {
    method: 'POST',
    credentials: 'include',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  }).then((response) => response.json()) as Promise<ThumbnailsCredentialsSchema>;
};

export const initializeThumbnailsSession = (fetch: typeof window.fetch) => async (host: string, cloudName: string, token: string) => {
  await fetch(`//${host}/${cloudName}/thumbnails/authorize`, {
    method: 'POST',
    credentials: 'include',
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded',
    }),
    body: new URLSearchParams({ token }),
  });
};
